// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"21fbf736","551":"0f194269"}[chunkId] + ".chunk.css";
};